import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { assertUnreachable } from '../../../../../util/assertUnreachable';

export const questionCountOptions = [5, 10, 15];

interface GenerateQuestionState {
  includeExplanation: boolean;
  questionCount: typeof questionCountOptions[number];
  [QuestionTypes.MultipleChoice]: boolean;
  [QuestionTypes.TrueFalse]: boolean;
  [QuestionTypes.FreeResponse]: boolean;
}

export type GenerateQuestionAction =
  | { type: 'ResetDialog' }
  | {
      type: 'QuestionTypeChange';
      payload: { questionType: string; value: boolean };
    }
  | { type: 'NumberQuestionChange'; payload: { value: number } }
  | {
      type: 'IncludeExplanationChange';
      payload: { includeExplanations: boolean };
    };

const initialState: GenerateQuestionState = {
  includeExplanation: true,
  questionCount: 10,
  [QuestionTypes.MultipleChoice]: true,
  [QuestionTypes.TrueFalse]: true,
  [QuestionTypes.FreeResponse]: true,
};

function reducer(state: GenerateQuestionState, action: GenerateQuestionAction) {
  switch (action.type) {
    case 'QuestionTypeChange': {
      const { questionType, value } = action.payload;
      return { ...state, [questionType]: value };
    }
    case 'IncludeExplanationChange': {
      const { includeExplanations } = action.payload;
      return { ...state, includeExplanation: includeExplanations };
    }
    case 'NumberQuestionChange': {
      const { value } = action.payload;
      return { ...state, questionCount: value };
    }
    case 'ResetDialog': {
      return { ...initialState };
    }
    default:
      assertUnreachable(action);
  }
}

const baseGenerateQuestionAtom = atomWithStorage<GenerateQuestionState>(
  'generateQuestion',
  initialState
);
export const generateQuestionAtom = atom(
  (get) => get(baseGenerateQuestionAtom),
  (get, set, action: GenerateQuestionAction) => {
    set(
      baseGenerateQuestionAtom,
      reducer(get(baseGenerateQuestionAtom), action)
    );
  }
);

export function checkIsQuestionTypeEmpty(
  multipleChoice: boolean,
  trueFalse: boolean,
  shortAnswers: boolean
) {
  return !multipleChoice && !trueFalse && !shortAnswers;
}
